import fetch from '@/utils/fetch'
import axios from 'axios'
import {
  optionSet
} from '@/utils/common.js'

/** 获取数据字典方法 */
export function getType(obj) {
  return new Promise((resolve, reject) => {
    fetch({
      url: '/api/system/concept/' + obj + '/concepts',
      method: 'get'
    }).then(res => {
      resolve({
        ...res,
        result: (res.result || []).map(item => {
          const reg = /^\d+$/
          let code = item.code
          // 判断是否是整数
          if (reg.test(item.code) === true) {
            code = Number(item.code)
          }
          return {
            ...item,
            code
          }
        })
      })
    })
  })
}
// 新 门店渠道树形结构
export function getChanneltree(obj) {
  return fetch({
    url: '/api/system/channel/tree',
    method: 'get'
  })
}

export function getall(obj) {
  const functionList = []
  for (let i = 0; i < obj.length; i++) {
    functionList.push(getType(obj[i]))
  }
  return axios.all(functionList)
}

/**
 * 批量获取type
 * @param {[{key:'服务端key',array:'赋值的数组'}]} list
 */
export function getOptions(list) {
  return new Promise((resolve, reject) => {
    const functionList = []
    for (let i = 0; i < list.length; i++) {
      functionList.push(getType(list[i].key))
    }
    return axios.all(functionList).then(array => {
      array.forEach((element, index) => {
        optionSet(element, list[index].array)
      })
      resolve()
    })
  })
}

/*
  fun  请求方法
  list 请求的参数集合
  sign 集合中的对应参数 传入null不使用
*/
export function requestAll(fun, list, sign = 'id') {
  const functionList = []
  for (let i = 0; i < list.length; i++) {
    let params = ''
    if (sign == null) {
      params = list[i]
    } else {
      params = list[i][sign]
    }
    functionList.push(fun(params))
  }
  return axios.all(functionList)
}
// 指标&告警 根据渠道查询关联策略
export function monitorConfiggetChannel(data) {
  return fetch({
    url: '/api/cooler/monitorConfig/getChannel',
    method: 'post',
    data
  })
}
